import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";

import { BaseFlex } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const Container = styled(BaseFlex)<{ isDisabled: boolean }>`
    margin: 24px 16px 16px 0;

    .send-invite-btn {
        background-color: ${({ isDisabled }) =>
            isDisabled ? `${colorsPalettes.carbon[200]}` : `${colorsPalettes.blue[400]}`};
    }
`;
